export const articles = [
	{
		title: "New Architecture of React Native",
		desc: "React Native 0.76 新架構中的 JSI、Turbo Modules 與 Fabric",
		tags: ["react native", "architecture"],
		link: "https://blog.errorbaker.tw/posts/ruofan/new-architecture-react-native/",
		external: true,
		isNew: false,
		published: "26 Jan 2025",
		readTime: "5 min read",
	},
	{
		title: "Scroll-driven Animations",
		desc: "什麼是捲動畫面時會驅動的動畫呢？",
		tags: ["scroll-driven animations"],
		link: "https://blog.errorbaker.tw/posts/ruofan/scroll-driven-animations/",
		external: true,
		isNew: false,
		published: "19 Oct 2023",
		readTime: "1 min read",
	},
	{
		title: "At a glance of Neo4j",
		desc: "以 Neo4j 為例和大家分享什麼是 graph DB",
		tags: ["graph DB"],
		link: "https://blog.errorbaker.tw/posts/ruofan/neo4j/",
		external: true,
		isNew: false,
		published: "09 Oct 2022",
		readTime: "1 min read",
	},
	{
		title: "Setup your react native project",
		desc: "設置 react native 建制過程",
		tags: ["react native"],
		link: "https://blog.errorbaker.tw/posts/ruofan/react-native/",
		external: true,
		isNew: false,
		published: "13 Aug 2022",
		readTime: "1 min read",
	},
	{
		title: "HSTORE vs JSONB in PostgreSQL",
		desc: "在 PostgreSQL 中 HSTORE 與 JSONB 的差別",
		tags: ["PostgreSQL"],
		link: "https://blog.errorbaker.tw/posts/ruofan/postgresql-datatypes/",
		external: true,
		isNew: false,
			published: "29 Jan 2022",
		readTime: "1 min read",
	},
	{
		title: "用 sheetJS 匯出 excel",
		desc: "透過 sheetJS 將資料匯出成 excel 格式",
		tags: ["sheetJS"],
		link: "https://blog.errorbaker.tw/posts/ruofan/xlsx/",
		external: true,
		isNew: false,
		published: "22 May 2022",
		readTime: "1 min read",
	},
	{
		title: "儲存資料到 firestore 前，需要注意哪些事？",
		desc: "firestore 使用上的限制",
		tags: ["firestore", "Usage and limits"],

		link: "https://blog.errorbaker.tw/posts/ruofan/firestore/",
		external: true,

			published: "16 Apr 2022",
		readTime: "1 min read",
	},
	{
		title: "web Push Notifications",
		desc: "Firebase Cloud Messaging 傳送通知到 web",
		tags: [
			"Firebase Cloud Messaging",
			"web Push Notifications",
			"service worker",
		],
		github_url: "https://github.com/ruofanwei/vue-fcm",
		link: "https://blog.errorbaker.tw/posts/ruofan/fcm/",
		external: true,

		published: "13 Mar 2022",
		readTime: "1 min read",
	},
	{
		title: "用 Vue 實作 Infinite Scroll",
		desc: "實作 Infinite Scroll ",
		tags: ["vue"],
		github_url: "https://github.com/ruofanwei/vue-infinite-scroll",
		link: "https://blog.errorbaker.tw/posts/ruofan/vue-infinite-scroll/",
		external: true,

		published: "06 Feb 2022",
		readTime: "1 min read",
	},
	{
		title: "A simple RESTful api with Go",
		desc: "實作簡單的 restful api 來認識 Golang",
		tags: ["Golang"],
		github_url: "https://github.com/ruofanwei/go-rest-api",
		link: "https://blog.errorbaker.tw/posts/ruofan/go-restful-api/",
		external: true,

		published: "01 Jan 2021",
		readTime: "1 min read",
	},
	{
		title: "用 Fireorm interact with Cloud Firestore",
		desc: "Fireorm 的基本操作",
		tags: ["Firestore", "Fireorm"],
		link: "https://blog.errorbaker.tw/posts/ruofan/express-firestore/",
		github_url: "https://github.com/ruofanwei/express-firestore",
		external: true,
		published: "17 Dec 2021",
		readTime: "1 min read",
	},

	{
		title: "用 NextAuth 實作第三方登入",
		desc: "NextAuth 實作第三方登入",
		tags: ["nextJS", "NextAuth"],
		link: "https://blog.errorbaker.tw/posts/ruofan/next-auth/",
		github_url: "https://github.com/ruofanwei/next-app",
		external: true,
		published: "04 Dec 2021",
		readTime: "1 min read",
	},
	{
		title: "render quill delta 的方式",
		desc: "Quill 實作 在 client 端一致的渲染出後台在 text editor 送出的資料",
		tags: ["react", "Quill", "delta"],
		link: "https://blog.errorbaker.tw/posts/ruofan/react-quill/",
		github_url:
			"https://github.com/ruofanwei/next-app/tree/feature/quill-delta",
		external: true,
		published: "07 Nov 2021",
		readTime: "1 min read",
	},
	{
		title: "mongoose 中的 aggregate",
		desc: "認識 aggregate 的基本操作",
		tags: ["mongoose", "aggregate", "back-end"],
		link: "https://blog.errorbaker.tw/posts/ruofan/mongoose-aggregate/",
		github_url: "https://github.com/ruofanwei/express-mongoose",
		external: true,
		published: "03 Oct 2021",
		readTime: "1 min read",
	},
	{
		title: "svelte 結合 firebase 實作登入",
		desc: "使用 firebase google login 以及搭配 xstate 的實作",
		tags: ["firebase", "svelte", "xstate"],
		link: "https://blog.errorbaker.tw/posts/ruofan/svelte/",
		github_url: "https://github.com/ruofanwei/svelte-xstate-app",
		external: true,
		published: "04 Sep 2021",
		readTime: "1 min read",
	},
	{
		title: "用 k6 為 api 做 Load Testing",
		desc: "如果你對於這個工具感到好奇，可以看看這篇",
		tags: ["k6", "load testing", "back-end"],
		link: "https://blog.errorbaker.tw/posts/ruofan/k6-load-testing/",

		external: true,
		published: "07 Aug 2021",
		readTime: "1 min read",
	},
];
